import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import Cookies from 'js-cookie'

const HOST = '/api'

const axiosInstance: AxiosInstance = axios.create({
  baseURL: HOST,
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
})

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const csrfToken = Cookies.get('csrftoken')
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    const status = error?.response?.status
    const reason = error?.response?.data || error?.response?.statusText
    const hasCsrf = !!Cookies.get('csrftoken')
    const isUnsafeMethod = ['post', 'put', 'patch', 'delete'].includes(
      (originalRequest?.method || '').toLowerCase(),
    )

    if (
      status === 403 &&
      isUnsafeMethod &&
      !originalRequest?._csrfRetry &&
      (!hasCsrf || (typeof reason === 'string' && reason.includes('CSRF')))
    ) {
      try {
        originalRequest._csrfRetry = true
        // CSRF 쿠키 프라이밍
        await axiosInstance.get('/user/')
        return axiosInstance(originalRequest)
      } catch (e) {
        // fallthrough
      }
    }
    return Promise.reject(error)
  },
)

export default axiosInstance
